import config from "@Config/index";
import axios from "axios";

const fetchInventory = async ({ id, user_currency, selectedLang }: any) => {
  const methods = [
    "active_children",
    "inventory_custom_form",
    "meta",
    "pricing",
    "offers",
    "region_parent_city_canonical",
    "payment_types",
    "features",
  ]
    .filter(Boolean)
    .join(",");

  const params: any = {
    type: "empty",
    cache: false,
    use_java_api: true,
    methods,
    only: "location,description,canonical_name,name,images,tags,status,region_id,id,payment_before_bookform,is_local_non_commissionable,provider_id,features",
    user_currency,
    lang: selectedLang || "en",
  };
  if (config.IS_CHINA_APP) {
    params.is_china_bookform = true;
  }

  return axios.get(`${config.API_URL}/api/v0/inventories/${id}`, {
    params,
    headers: { "X-Use-Java-Api": "true" },
  });
};

export default fetchInventory;
